(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/utils/utils.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/utils/utils.js');
"use strict";


svs.ticketsValidate.utils.getShortNameByTicketId = ticketId => {
  let shortName;
  try {
    shortName = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId).shortName;
  } catch (e) {}
  return shortName;
};
svs.ticketsValidate.utils.getBrandByTicketId = ticketId => {
  let brand;
  try {
    brand = svs.ticketgames.ticketMappings.productMappings.getProductByTicketId(ticketId).branding;
  } catch (e) {}
  return brand;
};
svs.ticketsValidate.utils.leaveInAccountDialog = _ref => {
  let {
    onValidateNewTicket,
    brand,
    trackType
  } = _ref;
  return svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'thumbs-up',
    title: 'Toppen!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Nu vilar din vinst tryggt på ditt spelkonto och kan bland annat användas för att köpa nya spel.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'All information om dina köp och vinster hittar du i Mina spel.'
    }],
    actions: [{
      title: 'Rätta ny lott',
      callback: (e, forms, dialog) => {
        dialog === null || dialog === void 0 || dialog.close();
        onValidateNewTicket(e, 'B');
      }
    }, {
      title: 'Jag är klar',
      callback: (e, forms, dialog) => {
        svs.ticketgames.ticketUtility.utils.tracking.trackValidateKeepWinChosen(trackType);
        dialog === null || dialog === void 0 || dialog.close();
        let ticketsValidateDoneKeepWinUrl;
        switch (brand) {
          case 'triss':
            ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateDoneKeepWinTriss');
            break;
          case 'skrapspel':
            ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateDoneKeepWinSkrapspel');
            break;
          default:
            ticketsValidateDoneKeepWinUrl = svs.core.urlMapping.get('ticketsValidateManual');
        }
        svs.utils.url.navigate(ticketsValidateDoneKeepWinUrl);
      }
    }]
  }));
};

 })(window);